import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { APPROVE_REGION, OPEN_REGION_LIST, SET_ALL_REGIONS_LIST, SET_EXPECTED_REGIONS, SET_LOCALE, SET_REGION, SHOULD_CONFIRM_REGION } from "../actions/actionTypes";
export function regionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    regions: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === SET_EXPECTED_REGIONS) {
    var newRegions = _objectSpread(_objectSpread({}, state.regions), action.payload);
    return _objectSpread(_objectSpread({}, state), {}, {
      regions: newRegions
    });
  }
  if (action.type === SET_ALL_REGIONS_LIST) {
    var _newRegions = _objectSpread(_objectSpread({}, state.regions), {
      originalList: action.payload
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      regions: _newRegions
    });
  }
  if (action.type === SET_REGION) {
    var _newRegions2 = _objectSpread(_objectSpread({}, state.regions), {}, {
      currentRegion: action.payload
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      regions: _newRegions2
    });
  }
  if (action.type === SHOULD_CONFIRM_REGION) {
    return _objectSpread(_objectSpread({}, state), action.payload);
  }
  if (action.type === APPROVE_REGION) {
    return _objectSpread(_objectSpread({}, state), {}, {
      expectedRegion: null
    });
  }
  if (action.type === OPEN_REGION_LIST) {
    return _objectSpread(_objectSpread({}, state), {}, {
      regionListOpened: true
    });
  }
  if (action.type === SET_LOCALE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      locale: action.payload
    });
  }
  return state;
}